/**
 * Implements a Behavior to enable Chosen on dropdown options.
 */

import Marionette from "backbone.marionette";
import "chosen-js";

import "../../../sass/chosen-overrides.scss";

class Chosen extends Marionette.Behavior {
  defaults() {
    return {
      selector: ".chosen-select",
      opts: {
        placeholder_text_single: "Choose an option...",
        placeholder_text_multiple: "Choose some options...",
        // don't search when there are fewer than 10 choices
        disable_search_threshold: 10,
        // allow deselect on Single Selects
        allow_single_deselect: true,
      },
    };
  }

  initialize() {
    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);
  }

  events() {
    return {
      "shown.bs.dropdown": "_apply",
      "shown.bs.modal": "_apply",
    };
  }

  _apply() {
    // initialize Chosen on default selector within current view
    this.$(this.options.selector).chosen(this.options.opts);
  }

  // custom method triggered by child views
  onContentRendered() {
    this._apply();
  }

  onReset() {
    // Updates options after the form is reset. This action is delayed by
    // 200ms to allow the form DOM to reset first.
    _.delay(() => {
      this.$(this.options.selector).trigger("chosen:updated");
    }, 200);
  }
}

export { Chosen as default };
